import React from "react";
import {
  Box,
  Select,
  Avatar,
  MenuItem,
  Typography,
  Chip,
  useTheme,
} from "@mui/material";
import { useMedia } from "../context/MediaContext";
import { useAuthStore } from "../store/authStore";
import { useCurrencyOptions } from "../hooks/useCurrencyOptions";
import CurrencyIcon from "./CurrencyIcon";

const ChoosingCurrency: React.FC = () => {
  const { curr, changeCurrency } = useAuthStore();
  const { isMobile400 } = useMedia();
  const theme = useTheme();
  const options = useCurrencyOptions();
  const active = options.find((option) => option.code === curr);

  return (
    <Select
      value={active ? curr : ""}
      aria-label="Валюта отображения"
      IconComponent={() => null}
      onChange={(e) => changeCurrency(e.target.value)}
      MenuProps={{ disableScrollLock: true }}
      sx={{
        minWidth: 40,
        cursor: "pointer",
        borderRadius: "12px",
        "& .MuiSelect-select": {
          padding: 0 + " !important",
          display: "flex",
          alignItems: "center",
          height: "50px",
        },
        "& .MuiOutlinedInput-input": {
          padding: 0 + " !important",
          display: "flex",
          alignItems: "center",
          height: "50px",
        },
        "& .MuiInputBase-input": {
          padding: 0 + " !important",
          display: "flex",
          alignItems: "center",
          height: "50px",
        },
        "& fieldset": { border: "none" },
      }}
      renderValue={() => (
        <Chip
          sx={{
            px: 0.5,
            height: "42px",
            minWidth: isMobile400 ? "52px" : "100px",
            border: `1px solid ${theme.palette.divider}`,
            backgroundColor: theme.palette.background.paper,
            "& .MuiChip-avatar": {
              width: "30px",
              height: "30px",
              marginRight: isMobile400 ? 0 : "8px",
            },
            "& .MuiChip-label": {
              fontSize: 14,
              fontWeight: 700,
              color: theme.palette.text.primary,
              display: isMobile400 ? "none" : "block",
            },
          }}
          avatar={
            <Avatar
              sx={{ backgroundColor: "transparent" }}
              alt=""
              // Avatar ждёт картинку, но значок умеет и кружок с кодом.
              children={
                <CurrencyIcon
                  code={curr}
                  img={active?.img}
                  size={30}
                  fallback="none"
                />
              }
            />
          }
          label={curr}
        />
      )}
    >
      {options.map((option) => (
        <MenuItem key={option.code} value={option.code}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: 2,
              width: "220px",
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
              <CurrencyIcon code={option.code} img={option.img} />
              <Typography fontWeight={600}>{option.label}</Typography>
            </Box>
            <Typography variant="body2" color="text.secondary" fontWeight={700}>
              {option.code}
            </Typography>
          </Box>
        </MenuItem>
      ))}
    </Select>
  );
};

export default ChoosingCurrency;
